export const firebaseConfig = {
    apiKey: "AIzaSyB11kCjblpCMhzdi_Mpp7oT2XKMRRrkaFE",
    authDomain: "creative--agency.firebaseapp.com",
    databaseURL: "https://creative--agency.firebaseio.com",
    projectId: "creative--agency",
    storageBucket: "creative--agency.appspot.com",
    messagingSenderId: "112553336067",
    appId: "1:112553336067:web:18c65b5ddfdedf7595dd36"
};